module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-ThinItalic.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-ThinItalic.woff2
// module id = 71
// module chunks = 8